// extracted by mini-css-extract-plugin
export default {"thumbnail":"_2RNdE___IndexPage-module__thumbnail"};